export const ACCEPTED_MEDIA_MIME_PREFIXES = ['image/', 'video/'];
export const MAX_UPLOAD_TOTAL_MB = 20;
export const BYTES_PER_KB = 1024;
export const KB_PER_MB = 1024;
export const BYTES_PER_MB = BYTES_PER_KB * KB_PER_MB;
export const MAX_UPLOAD_TOTAL_BYTES = MAX_UPLOAD_TOTAL_MB * BYTES_PER_MB;

export const formatFileSizeMb = (bytes) => (bytes / BYTES_PER_MB).toFixed(2);

export const isAcceptedMediaFile = (file) => ACCEPTED_MEDIA_MIME_PREFIXES.some((prefix) => file.type.startsWith(prefix));

export const validateMediaFiles = (existingFiles, incomingFiles) => {
  const invalidFile = incomingFiles.find((file) => !isAcceptedMediaFile(file));
  if (invalidFile) {
    return `Only photo and video files can be uploaded. Please remove ${invalidFile.name}.`;
  }

  const currentTotal = existingFiles.reduce((total, item) => total + item.file.size, 0);
  const incomingTotal = incomingFiles.reduce((total, file) => total + file.size, 0);
  if (currentTotal + incomingTotal > MAX_UPLOAD_TOTAL_BYTES) {
    return `Uploads are optional, but photos/videos must be ${MAX_UPLOAD_TOTAL_MB}MB total or less so they can be sent with your request.`;
  }

  return '';
};